import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../api';
import toast from 'react-hot-toast';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 2rem 1rem;
`;

const Card = styled.div`
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.15);
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 1.4rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
`;

const Input = styled.input`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 0.65rem 0.8rem;
  font-size: 0.95rem;
  margin-bottom: 1rem;
  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.3);
  }
`;

const Button = styled.button`
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
`;

const FooterText = styled.p`
  font-size: 0.85rem;
  color: #6b7280;
  margin-top: 1rem;
  text-align: center;
`;

const FooterLink = styled(Link)`
  color: #4f46e5;
  font-weight: 600;
  text-decoration: none;
`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('E-posta gerekli');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      toast.success('Bağlantı gönderildiyse e-postanı kontrol et.');
      setEmail('');
    } catch (err) {
      const message = err.response?.data?.error || 'İşlem sırasında hata oluştu';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <Card>
        <Title>Şifremi Unuttum</Title>
        <Subtitle>E-posta adresinizi yazın, şifre yenileme bağlantısını gönderelim.</Subtitle>
        <form onSubmit={handleSubmit}>
          <div>
            <Label>E-posta</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ornek@mail.com"
            />
          </div>
          <Button type="submit" disabled={loading}>
            {loading ? 'Gönderiliyor...' : 'Şifre Yenileme Linki Gönder'}
          </Button>
        </form>
        <FooterText>
          <FooterLink to="/login">Giriş ekranına dön</FooterLink>
        </FooterText>
      </Card>
    </PageContainer>
  );
};

export default ForgotPassword;
